import { components } from 'type/ReportServiceSchema';
import {
  InsightsLifecycleQuestionItemModel,
  mapInsightsLifecycleQuestionItemDtoToModel,
} from 'api/dto/new/Common/InsightsLifecycleQuestionItem.dto';
import { Insight } from 'model/Insight';

export type InsightsLifecycleCombinedDto = components['schemas']['InsightsLifecycleCombinedReportResultDTO'];

export type InsightsLifecycleCombinedModel = Readonly<{
  numberOfRespondents: number;
  questions: InsightsLifecycleQuestionItemModel[];
}>;

// TODO: use this mapper later for new endpoint proper typing - https://buzzing.atlassian.net/browse/RPT-493
export const mapInsightsLifecycleCombinedDtoToModel = (
  dto: InsightsLifecycleCombinedDto
): InsightsLifecycleCombinedModel => ({
  numberOfRespondents: dto.numberOfRespondents,

  questions: dto.questions.map(mapInsightsLifecycleQuestionItemDtoToModel),
});

export const mapInsightsLifecycleCombinedDtoToInsightCombine = (
  dto: InsightsLifecycleCombinedDto
): Insight.Combine => ({
  numberOfEmployees: dto.numberOfRespondents,

  data: dto.questions.map((questionItem) => ({
    question: {
      id: questionItem.question.id,
      content: questionItem.question.content,
      kind: questionItem.question.kind,
    },

    answers: questionItem.answers.map((answer) => ({
      count: answer.count,
      score: answer.score,
      option: {
        id: answer.option.id,
        label: answer.option.label,
      },

      trendPlotData: answer.monthlyAggregatedTrendData.map((trend) => trend.value ?? null),
    })),
    // Default value as this field is not present in the DTO
    respondentProtection: false,
  })),
});
